import React from 'react';
import styled from "styled-components";
import { motion, AnimatePresence } from 'framer-motion';
import imgGiftBox from 'src/assets/images/main_section/img_giftbox.png';
import imgMainEvent from 'src/assets/images/main_section/img_main_event.png';
import imgMainPhone from 'src/assets/images/main_section/img_main_phone.png';
import imgMainSns from 'src/assets/images/main_section/img_main_sns.png';
import imgMainStarbucks from 'src/assets/images/main_section/img_main_starbucks.png';
import imgMainStream from 'src/assets/images/main_section/img_main_stream.png';
import imgGooglePlay from 'src/assets/images/img_googleplay.png';
import imgAppStore from 'src/assets/images/img_app_store.png';
import {
    Noto_Description1_r14,
    Noto_Description2_r12,
    Noto_heading1_r24
} from "src/styles/font/NotoSansKrFonts";
import {
    Gmarket_DisPlay1_b80,
    Gmarket_DisPlay2_b50
} from "src/styles/font/GmarketSansFonts";
import {
    BackgroundVideo as StyledBackgroundVideo,
    LineBreak, LinePoint,
    Section, VideoWrapper,
} from "src/styles/common/sectionStyles";
import {
    mediaUnderLaptop,
    mediaLaptop,
    mediaTablet,
    mediaUnderTablet,
    mediaMaxWidthMobile,
    mediaMinHeight,
    mediaUnderMinHeight,
    mediaMaxHeight
} from "src/styles/mediaQuery";
import {Link} from "react-router-dom";


const textContainerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            when: 'beforeChildren',
            staggerChildren: 0.5,
        },
    },
};

const textItemVariants = {
    hidden: {
        opacity: 0,
        y: 45
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            damping: 12,
            stiffness: 100,
        },
    },
};
const imgContainerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            when: 'beforeChildren',
            staggerChildren: 0.2,
        },
    },
};
const imgPhoneVariants = {
    hidden: {
        opacity: 0,
        y: 45
    },
    visible: {
        opacity: 1,
        y: 0,
    },
};
const imgItemVariants = {
    hidden: {
        opacity: 0,
        y: 35
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'spring',
            damping: 12,
            stiffness: 100,
        },
    },
};
const textVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,
        transition: {
            delay: 2.5,
        },
    },
};
function MainSectionView() {
    return (
        <>
            <Section>
                <VideoWrapper>
                    <BackgroundVideo
                        autoPlay
                        muted
                        preload="none"
                        playsInline
                        aria-hidden="true"
                    >
                        <source src={"/videos/video_main.mp4"} type="video/mp4"/>
                    </BackgroundVideo>
                </VideoWrapper>
                <Inner>
                    <ContentsWrap>
                        <AnimatePresence mode="wait">
                            <Contents
                                variants={textContainerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{
                                    once: true,
                                    amount: 0.3
                                }}
                            >
                                <ImageBox variants={textItemVariants}/>
                                <TextWrapper variants={textItemVariants}>
                                    <h1>
                                    <Line >세상의 모든 이벤트</Line>
                                    <br/>
                                    <TitleLine>
                                        <LinePoint className="main-color">이벤트U</LinePoint>가
                                        <br/> 연결해 드려요
                                    </TitleLine>
                                    </h1>
                                </TextWrapper>
                                <ButtonWrap variants={textItemVariants}>
                                    <DownloadButton
                                        to={'https://play.google.com/store/apps/details?id=com.datau.eventu'} target="_blank"
                                        aria-label="구글플레이 스토어에서 앱 다운로드"
                                        className="google-play"
                                    >
                                        Google Play
                                    </DownloadButton>
                                    <DownloadButton
                                        to={'https://itunes.apple.com/kr/app/id6602889410'} target="_blank"
                                        aria-label="앱스토어에서 앱 다운로드"
                                        className="app-store"
                                    >
                                        App Store
                                    </DownloadButton>
                                </ButtonWrap>
                            </Contents>
                        </AnimatePresence>
                        <Contents>
                            <ImageContainer  variants={imgContainerVariants}
                                             initial="hidden"
                                             whileInView="visible"
                                             viewport={{
                                                 once: true,
                                                 amount: 0.3
                                             }}>
                                <ImageItem  className="img-phone" variants={imgPhoneVariants}>
                                    <img src={imgMainPhone} alt=""/>
                                    <ImageText variants={textVariants}>
                                        해당 브랜드나 제품은 예시이며, 시기에 따라서는 해당 브랜드 제품과<LineBreak className="mob"/> 관련한 이벤트가 없을 수 있습니다.
                                    </ImageText>
                                </ImageItem>
                                <ImageItem className="img-stream"  variants={imgItemVariants}>
                                    <img src={imgMainStream} alt=""/>
                                </ImageItem>
                                <ImageItem  className="img-sns"  variants={imgItemVariants}>
                                    <img src={imgMainSns} alt=""/>
                                </ImageItem>
                                <ImageItem className="img-starbucks"  variants={imgItemVariants}>
                                    <img src={imgMainStarbucks} alt=""/>
                                </ImageItem>
                                <ImageItem  className="img-event"  variants={imgItemVariants}>
                                    <img src={imgMainEvent} alt=""/>
                                </ImageItem>
                            </ImageContainer>
                        </Contents>
                    </ContentsWrap>
                </Inner>
            </Section>

        </>
    );
}

export default MainSectionView;


const Inner = styled.div`
  position: relative;
  width: 100%;
  max-width: 1460px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

    ${mediaMaxHeight} {
      transform: scale(.85);
    }

    ${mediaUnderLaptop} {
      transform: scale(.85);
    }

    ${mediaMinHeight} {
      transform: scale(.70);
    }

    ${mediaUnderMinHeight} {
      transform: scale(.55);
    }

    ${mediaTablet} {
      transform: scale(1) !important;
    }
`;


const ContentsWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  ${mediaTablet} {
    flex-flow: column;
    gap:5vw;
  }
`;

const Contents = styled(motion.div)`
  position: absolute;
  ${mediaTablet} {
    position: relative;
  }
  &:nth-child(1) {
    left: 0;
    ${mediaTablet} {
      left:unset
    }

  }

  &:nth-child(2) {
    right: 0;
    width: 100%;
    max-width: 950px;
    height: 762px;
    ${mediaTablet} {
      max-width: 677px;
      height: 543px;
      right:unset;
    }
    ${mediaUnderTablet} {
      max-width: 420px;
      height: 322px;
      right:unset;
    }
  }
`;

const BackgroundVideo = styled(StyledBackgroundVideo)`
  ${mediaUnderTablet} {
    object-position:right center
  }
  ${mediaMaxWidthMobile} {
    object-position:calc(50% - 320px) center
  }
`
const TextWrapper = styled(motion.div)`
  margin-top: 28px;
  ${mediaTablet} {
    text-align: center;
    margin-top: unset;
  }
`;

const Line = styled.strong`
  ${Gmarket_DisPlay2_b50};
  ${mediaTablet} {
    font-size: 24px;
    line-height: 1.4;
  }
  ${mediaUnderTablet} {
    font-size: 24px;
  }
`;

const TitleLine = styled.span`
  ${Gmarket_DisPlay1_b80};
  ${mediaTablet} {
    font-size: 38px;
    line-height: 1.4;
  }
  ${mediaUnderTablet} {
    font-size: 28px;
  }
`;



const ImageBox = styled(motion.div)`
  width: 100px;
  height: 100px;
  background: url(${imgGiftBox}) no-repeat center center/cover;
  ${mediaTablet} {
    display: none;
  }
`;

const ButtonWrap = styled(motion.div)`
  display: flex;
  flex-flow: row nowrap;
  gap: 14px;
  margin-top: 80px;
  position: relative;
  z-index: 1;

  ${mediaLaptop} {
    margin-top: 60px;
  }

  ${mediaTablet} {
    margin-top: 16px;
    gap: 8px;
  }

  ${mediaUnderTablet} {
    margin-top: 10px;
    gap: 5px;
  }
`;

const DownloadButton = styled(Link)`
  ${Noto_heading1_r24};
  position: relative;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  padding: 22px 32px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255);
  box-shadow: 0 5px 20px 0 rgba(108, 60, 157, 0.1);
  color: var(--point-color-2);
  transition: color ease-in-out .3s;
  @media (hover: hover) and (pointer: fine) {
    &:hover{
      color: var(--point-color-1);
    }
  }
  &::before {
    content: '';
    display: inline-block;
    width: 36px;
    height: 36px;
  }

  &.google-play::before {
    background: url(${imgGooglePlay}) no-repeat center/cover;
  }

  &.app-store::before {
    background: url(${imgAppStore}) no-repeat center/cover;
  }

  ${mediaTablet} {
    ${Noto_Description1_r14};
    gap: 6px;
    padding: 14px 16px;
    border-radius: 12px;
    &::before {
      width: 16px;
      height: 16px;
    }
  }
`
const ImageContainer = styled(motion.ul)`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
`;

const ImageItem = styled(motion.li)`
  position: absolute;
  img {
    height: 100%;
    filter: drop-shadow(24px 52px 66px rgba(0, 0, 0, 0.09));
  }
  ${mediaTablet} {
    filter: drop-shadow(18px 38px 47px rgba(0, 0, 0, 0.09));
  }

  &.img-phone {
    display: flex;
    flex-flow:column;
    gap:20px;
    align-items: center;
    position: absolute;
    top: 0;
    right: 205px;
    width: 350px;
    height: 762px;
    z-index: 1;
    ${mediaTablet} {
      width: 249px;
      height: 543px;
      right: 0;
      left: 0;
      margin: 0 auto;
    }
    ${mediaUnderTablet} {
      width: 148px;
      height: 100%;
    }
  }

  &.img-stream {
    top: 0;
    left: 0;
    width: 311px;
    ${mediaUnderLaptop} {
      width: 280px;
      left: 80px;
    }
    ${mediaTablet} {
      width: 222px;
      left: -50px;
    }
    ${mediaUnderTablet} {
      width: 132px;
      height: 120px;
    }
  }

  &.img-sns {
    width: 210px;
    top: 315px;
    left: 198px;
    ${mediaTablet} {
      width: 150px;
      top: 225px;
      left: 85px;
    }
    ${mediaUnderTablet} {
      width: 89px;
      height: 118px;
      top: 133px;
      left: 30px;
    }
  }

  &.img-starbucks {
    width: 313px;
    bottom: 81px;
    right: 57px;
    z-index: 3;
    ${mediaTablet} {
      width: 223px;
      bottom: 70px;
      right: 100px;
    }
    ${mediaUnderTablet} {
      width: 132px;
      height: 35px;
      bottom: 50px;
      right: 50px;
    }
  }

  &.img-event {
    top: 149px;
    right: 0;
    width: 165px;
    ${mediaTablet} {
      width: 118px;
      top: 106px;
      right: 60px;
    }
    ${mediaUnderTablet} {
      width: 70px;
      height: 107px;
      top: 67px;
      right:20px;
    }
  }
`;

const ImageText = styled(motion.p)`
  ${Noto_Description2_r12};
  width: 320px;
  color: var(--point-color-3);
  text-align: center;
  word-break: keep-all;
  ${mediaTablet} {
    font-size: 10px;
  }
  ${mediaUnderTablet} {
    font-size: 7px;
  }
`;
